
import React from 'react';
import { CommonPageHeading } from '../../../CommonUtilities/CommonHeading/CommonPageHeading';
import PublicHeader from '../../../Header/PublicHeader';
import { Col, Row } from 'react-bootstrap';
import showVacancyData from '../../../../Assets/Merit-2025/Meritlist_round1.json';
import Sweetalert from '../../../CommonUtilities/CommonPopupAndAlerts/SweetAlerts';

export default function MeritList() {
    return (<React.Fragment>
        <PublicHeader />
        <div className='mt-5 px-2 pt-2'>
            <CommonPageHeading heading='MEGA DSC General Merit List -2025' back={true} />
            <div className='table-responsive generalmerittable'>
                <table className='table table-bordered'>
                    <thead style={{ background: 'beige' }}><tr><th style={{ width: "1%" }}>S.NO.</th><th style={{ width: "24%" }}>Post</th><th style={{ width: "75%" }} className='text-center'>District/Zone/State</th></tr></thead>
                    <tbody>
                        {showVacancyData?.map((s, index) => {
                            return (<tr key={s?.post} ><td style={{ background: 'azure' }}>{index + 1}. </td><td style={{ background: 'azure' }}><strong>{s.post}</strong></td><td>
                                <Row>{s?.districts?.map((d, index1) => {
                                    return (<Col md={2} key={index1} className='mt-2 '>
                                    <button button type='button' className='button-30 ' onClick={() => {
                                        if (d?.path) {
                                            window.open(d?.path)
                                        } else {
                                            Sweetalert('Coming Soon !!...', 'warning')
                                        }

                                    }}>{d?.dist_name}</button></Col>)
                                })}</Row></td></tr>)
                        })}</tbody>
                </table>
            </div>
        </div></React.Fragment>
    );
}
